import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

export class CheckoutSteps extends Component {
	state = {
        steps:[],            
	};

	componentDidMount() {         
        

        this.setState({ steps: [
            {"id":'1',"name":'Create your profile'},
            {"id":'2',"name":'Complete your profile'},
			{"id":'3',"name":'Select interests'},
			{"id":'4',"name":'Preferences'},
			{"id":'5',"name":'Finish up '},
        ] }); 
    }
	
	render() {
        return (
            <div className="checkout-steps bg-white py-md-4 position-absolute">
			    <ul className="d-flex align-items-center justify-content-center">
					{this.state.steps.map(
						(item, index) => {
							return (
								<li key={index} className={`d-flex align-items-center py-4 ${this.props.onboardStep.includes(item.id) ? `active` : ``} ${this.props.show === item.id ? `shows` : ``}`}>
									<span className="d-flex align-items-center justify-content-center rounded-circle steps mr-3">{item.id} </span>
									{item.name} 
								</li>
							);
						}
					)}				   
				</ul>
			</div>
		);
        
    }
}

CheckoutSteps.contextType = AppContext;
export default CheckoutSteps;



// WEBPACK FOOTER //
// ./src/components/general/include/CheckoutSteps.js